import React from 'react';
import { Gamepad2 } from 'lucide-react';

export const GamePage: React.FC = () => {
  return (
    <div className="text-center py-16">
      <Gamepad2 className="h-16 w-16 text-primary mx-auto mb-4" />
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Game Page
      </h1>
      <p className="text-muted-foreground">
        Game interface will be implemented here
      </p>
    </div>
  );
};